import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    maxHeight: theme.spacing(40),
    overflowY: 'auto',
  },
  empty: {
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
